module.exports = __webpack_public_path__ + "img/trees_white.43020189.svg";